import hatsApi from '@/services/hatsApi'

export default {
  login (params) {
    return hatsApi().post('/authentication/login', params)
  },
  logout () {
    return hatsApi().post('/authentication/logout')
  },
  refresh (params) {
    return hatsApi().post('authentication/refresh', params)
  },
  google2FAImage (params) {
    return hatsApi().post('authentication/login/image', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Auth.js